<template>
  <div class="home_wrap">
    <van-row class="topSection">
      <van-col span="4" style="text-align: left">
        <img
          src="../images/common/backArrow.png"
          @click="$router.go(-1)"
          class="imageback"
        />
      </van-col>
      <van-col span="20" style="text-align: right">
        <span style="color: #ffffff; font-size: 30px; font-weight: 700">{{
          $t("settings.language")
        }}</span>
      </van-col>
    </van-row>
    <van-row class="wrap">
      <div v-for="language in languageList" class="wrap_box" :key="language.id">
        <div class="item" @click="changeLang(language.lang_code, $event)">
          <div class="left flex_center">
            <div><img :src="language.flag" /></div>
            <div class="info" style="margin-left: 10px">
              {{ language[lang] }}
            </div>
          </div>
          <div v-if="lang == language.lang_code">✓</div>
        </div>
      </div>
    </van-row>
  </div>
</template>

<script>
import Vue from "vue";
import bsHeader from "../../components/bsHeader.vue";
import { Toast, Col, Row } from "vant";
import Fetch from "../../utils/fetch";
Vue.use(Row).use(Col);
export default {
  name: "language",
  components: {
    bsHeader,
  },
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      languageList: [],
    };
  },
  created() {},
  mounted() {
    this.getLanguageList();
  },
  methods: {
    changeLang(lang, event) {
      Toast.loading({
        // mask: true,
        duration: 200,
      });

      this.$loadLangAsync(lang).then((r) => {
        if (r) {
          this.lang = lang;
          this.$router.go(-1);
        } else {
          this.$toast.fail();
        }
      });
    },
    getLanguageList() {
      Fetch("/Tipslanguages/country").then((r) => {
        if (r.code == 1) {
          this.languageList = r.data;
        } else {
          Toast.fail(r.msg[this.lang]);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: url("../images/common/BgImg.png");
  background-size: 100% 100%;
}

.topSection {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 30px 15px 20px;
}

.imageback {
  height: 30px;
  width: auto;
}

.wrap {
  border: 1px solid #ffffff;
  border-radius: 13px;
  padding: 25px 15px;
  background: #ebebeb29;
  margin: 10px;
}

.back_left {
  background: url(../../views/images/item/back_b.png) no-repeat center center;
}
.big_tit {
  color: #000000;
}
.wrap_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  .item {
    height: 50px;
    width: 95%;
    padding: 16px 0;
    border-bottom: 1px solid #ececec;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);
    font-weight: bold;
    line-height: 20px;
    display: flex;
    justify-content: space-between;
    .right {
      width: 20px;
      height: 20px;
      background: url(../images/user/arrow.png) no-repeat center center;
      background-size: 100% 100%;
    }
    .right_info {
      color: rgba(0, 0, 0, 0.6);
    }
    .tips {
      color: rgba(0, 0, 0, 0.6);
      margin-left: auto;
      margin-right: 4px;
      font-weight: normal;
    }
    .left {
      img {
        width: 33px;
        margin-top: 5px;
      }
    }
  }
}

.wrap_box:first-child {
  margin-top: 0px;
}
</style>
